// Copyright (c) Bentley Systems
import { SVGProps, useEffect, useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import { AnimatedIconProps } from "./AnimatedIconProps";

const BottomRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#67b01a"
        fillOpacity="60%"
        stroke="#fff"
        strokeOpacity="0.6"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(5 5)"
       />
      <path
        fill="#fff"
        d="M2 2a.945.945 0 01-1 1 .945.945 0 01-1-1 .945.945 0 011-1 1.002 1.002 0 011 1m0 4a.945.945 0 01-1 1 1.002 1.002 0 01-1-1 .945.945 0 011-1 1.002 1.002 0 011 1m0 4a.945.945 0 01-1 1 1.002 1.002 0 01-1-1 .945.945 0 011-1 1.002 1.002 0 011 1m0 4a.945.945 0 01-1 1 1.002 1.002 0 01-1-1 .945.945 0 011-1 1.075 1.075 0 011 1M4 1h12v2H4zm0 4h12v2H4zm0 4h12v2H4zm0 4h12v2H4z"
        transform="matrix(1.8 0 0 2 12 10)"
       />
    </g>
  );
}

const TopRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#87cd1e"
        stroke="#83c444"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(0)"
       />
    </g>
  );
}

const ListAnim = (props: AnimatedIconProps) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (props.isFocused !== undefined) {setToggle(props.isFocused);}
  }, [props]);

  const rectangles = [
    <TopRectangle key="rectangle1" />,
    <BottomRectangle key="rectangle2" />,
  ];

  const springs = useSprings(
    rectangles.length, // the number of springs to create
    rectangles.map((el, index) => {
      return {
        transform: toggle
          ? `translate3d(0px, 0px, 0px)`
          : `translate3d(${index === 1 ? -5 : 5}px, 0px, 0px)`,
      };
    })
  );

  const animatedRectangles = springs.map((animatedStyle, index) => (
    // use `animated.g` instead of `g` as the `animatedStyle`
    // is a special react-spring flavour of the `style` property
    <animated.g
      key={index}
      style={animatedStyle} // apply the animated style
    >
      {rectangles[index]}
    </animated.g>
  ));

  return (
    <div
      onMouseOver={() => {
        if (props.isFocused === undefined) {setToggle(true);}
      }}
      onMouseOut={() => {
        if (props.isFocused === undefined) {setToggle(false);}
      }}
    >
      <svg
        style={{ height: "100%", width: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        viewBox="0 0 47 47"
      >
        {animatedRectangles}
      </svg>
    </div>
  );
};

export default ListAnim;
